<template>
  <div class="d-flex h-100 w-100 justify-content-center login-container">
    <div class="align-self-center">
      <div class="card login-panel">
        <div class="card-header">One-time password
          <div class="login-controls">
            <button :disabled="loading" @click="reloadQr" id="totp_new_key" class="btn">
              <icon name="spinner" pulse v-if="loading"></icon>
              <icon name="key" v-else></icon>
            </button>
            <b-tooltip target="totp_new_key" title="Generate new key"></b-tooltip>
          </div>
        </div>
        <div class="card-body">
          <b-form-group
            label="Token" label-for="token">
            <b-form-input ref="tokenInput" @keyup.prevent.native="kup" id="token"
                          v-model="token" required
                          placeholder="Enter token"
            ></b-form-input>
          </b-form-group>
        </div>
        <div slot="card-footer">
          <div class="register-footer">
            <btn-group class="btn-block btn-group">
              <b-button class="main-cancel-button" :disabled="loading" variant="secondary" @click="signOut"> Sign out</b-button>
              <b-button id="totp-btn" class="main-action-button" :disabled="loading" @click.stop.prevent="onSubmit" type="submit" variant="primary">
                Submit
              </b-button>
            </btn-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import series from 'async/series'
  import router from '../../router'
  import store from '../../store'
  import auth from '../../api/auth'
  import 'vue-awesome/icons/key'
  import 'vue-awesome/icons/spinner'

  export default {
    name: 'totp',
    data () {
      return {
        token: '',
        loading: false
      }
    },
    mounted () {
//      let errNotif = () => {
//        this.$notify({
//          title: 'ERROR',
//          text: 'Could not check status',
//          type: 'error'
//        })
//      }
//      this.$http.get('/api/totp-check')
//        .then(res => {
//          this.inputDisabled = false
//          if (res.body.status === 0) {
//            this.reloadQr()
//          }
//        }, res => {
//          errNotif()
//        })
    },
    methods: {
      signOut () {
        auth.signOut()
      },
      onSubmit () {
        this.loading = true
        store.commit('setIsLoading', true)
        series(
          [
            (clb) => {
              let formData = new FormData()
              formData.append('token', this.token)
              this.$http.post('/api/totp/', formData)
                .then(response => {
                  clb(null)
                }, response => {
                  clb(response.body)
                })
            },
            (clb) => {
              this.$http.get('/api/authed/')
                .then(res => {
                  if (res.body.authed && res.body.verified) {
                    clb(null, res.body)
                  } else {
                    clb('not verified')
                  }
                }, res => {
                  clb(res.body)
                })
            }
          ],
          (err, res) => {
            this.loading = false
            store.commit('setIsLoading', false)

            if (err) {
              this.$notify({
                title: 'ERROR',
                text: 'Could not verify token',
                type: 'error'
              })
            } else {
              if (res[1].authed) {
                store.commit('setVerified', true)
                store.commit('setUser', res[1].user)
                router.push('/')
              }
            }
          }
        )
      },
      handleOk () {

      },
      kup (e) {
        e.preventDefault()
        if (e.keyCode === 13) {
          this.onSubmit()
        }
      },
      reloadQr () {
        let errNotif = () => {
          this.$notify({
            title: 'ERROR',
            text: 'Could not send auth key',
            type: 'error'
          })
        }
        this.loading = true
        this.$http.get('/api/totp')
          .then(res => {
            if (res.body.status === 'OK') {
              this.$notify({
                title: 'SUCCESS',
                text: 'Please, check your email for next instructions',
                type: 'success'
              })
            } else {
              errNotif()
            }
            this.loading = false
          }, res => {
            this.loading = false
            errNotif()
          })
      }
    }
  }
</script>
<style lang="scss">
  .qr-content image {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/Totp.vue